/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* DynamoDB billing mode. 
*/
export enum DynamoDbBillingMode {
  DYNAMODB_BILLING_MODE_UNSPECIFIED = 'UNSPECIFIED',
  DYNAMODB_BILLING_MODE_PAY_PER_REQUEST = 'PAY_PER_REQUEST',
  DYNAMODB_BILLING_MODE_PROVISIONED = 'PROVISIONED'
}
